import { useEffect, useRef } from 'react'
import { useAriaAnnouncer } from '@nv/contexts'
import { Helmet } from 'react-helmet'

export const Announce = ({ title, setPageName = false, shouldAnnounce = true }) => {
  const announce = useAriaAnnouncer()
  const lastAnnounced = useRef('')

  useEffect(() => {
    if (setPageName) document.title = title

    if (shouldAnnounce && lastAnnounced.current !== title) {
      lastAnnounced.current = title
      announce(title)
    }
  }, [title, announce])

  if (setPageName) {
    return (
      <Helmet>
        <title>{title}</title>
      </Helmet>
    )
  }

  return null
}
